jQuery.noConflict();

(function ($) {

    $(document).ready(function () {

        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        $(".gallery-icon a").fancybox();

        $('a').removeClass('kc_button');
        
        function getCookie(c_name) {

            console.log(c_name);


            var c_value = document.cookie,
                c_start = c_value.indexOf(" " + c_name + "=");
            if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
            if (c_start == -1) {
                c_value = null;
            } else {
                c_start = c_value.indexOf("=", c_start) + 1;
                var c_end = c_value.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = c_value.length;
                }
                c_value = unescape(c_value.substring(c_start, c_end));
            }

            console.log(c_value);

            return c_value;
        }




        // Initialize and add the map
        if ($("#gmap").length > 0) {
            (function initMap() {

                let current_lang = getCookie('wp-wpml_current_language');

                console.log(current_lang);

                const main = { lat: 46.1178992, lng: 15.0137671 };

                const map = new google.maps.Map(document.getElementById("gmap"), {
                    zoom: 9,
                    center: main
                });

                const icon = '/var/www/clients/client0/web286/web/wp-content/themes/emigma/assets/icons/empty.jpg';

                let unit = '<p>ENOTA</p>';
                let hq = '<p>ENOTA</p>';

                if (current_lang == 'en') {
                    unit = '<p>UNIT</p>';
                    hq = '<p>HQ</p>';
                }

                // KOPER
                let koperContent =
                    '<div class="box-map d-flex align-items-start">' +
                    '<div class="location">' +
                    '<p class="mb-2">Koper</p>' +
                    '<div class="contact-info">' +
                    '<p class="mb-0">Vojkovo nabrežje 10</p>' +
                    '<p class="mb-1">+386 5 612 00 20</p>' +
                    '<p class="mb-1">simon.zgur@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    unit +
                    '</div>' +
                    '</div>';

                let koperWindow = new google.maps.InfoWindow({
                    content: koperContent
                });

                koperMarker = new google.maps.Marker({
                    position: { lat: 45.51, lng: 13.73 },
                    map,
                    icon: icon,
                })

                koperMarker.addListener('click', function () {
                    infowindow.open(map, koperMarker);
                });

                koperWindow.open(map, koperMarker);


                // Gorica 
                let goricaContent =
                    '<div class="box-map d-flex align-items-start">' +
                    '<div class="location">' +
                    '<p class="mb-2">Nova Gorica</p>' +
                    '<div class="contact-info">' +
                    '<p class="mb-0">Kolodvorska pot 12</p>' +
                    '<p class="mb-1">+386 5 335 39 40</p>' +
                    '<p class="mb-1">rado.sirk@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    unit +
                    '</div>' +
                    '</div>';

                // SEDEŽ = HQ
                // ENOTA = UNIT

                let goricaWindow = new google.maps.InfoWindow({
                    content: goricaContent
                });

                goricaMarker = new google.maps.Marker({
                    position: { lat: 45.95, lng: 13.642 },
                    map,
                    icon: icon,
                })

                goricaMarker.addListener('click', function () {
                    infowindow.open(map, goricaMarker);
                });

                goricaWindow.open(map, goricaMarker);


                // LJUBLJANA
                let ljContent =
                    '<div class="box-map d-flex align-items-start blue">' +
                    '<div class="location">' +
                    '<p class="mb-2">Ljubljana</p>' +
                    '<div class="contact-info">' +
                    '<p class="mb-0">Zaloška cesta 219</p>' +
                    '<p class="mb-1">+386 1 300 71 12</p>' +
                    '<p class="mb-1">darja.koleto@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    hq +
                    '</div>' +
                    '</div>';

                let ljWindow = new google.maps.InfoWindow({
                    content: ljContent
                });

                ljMarker = new google.maps.Marker({
                    position: { lat: 45.94, lng: 14.5112 },
                    map,
                    icon: icon,
                })

                ljMarker.addListener('click', function () {
                    infowindow.open(map, ljMarker);
                });

                ljWindow.open(map, ljMarker);


                // Brnik
                let brnikContent =
                    '<div class="box-map d-flex align-items-start">' +
                    '<div class="location">' +
                    '<p class="mb-2">Brnik</p>' +
                    '<div class="contact-info d-none">' +
                    '<p class="mb-1">Zaloška cesta 219</p>' +
                    '<p class="mb-1">+386 1 300 71 12</p>' +
                    '<p class="mb-1">dean.persic@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    unit +
                    '</div>' +
                    '</div>';


                let brnikWindow = new google.maps.InfoWindow({
                    content: brnikContent
                });

                brnikMarker = new google.maps.Marker({
                    position: { lat: 46.22, lng: 14.4518 },
                    map,
                    icon: icon,
                })

                brnikMarker.addListener('click', function () {
                    infowindow.open(map, brnikMarker);
                });

                brnikWindow.open(map, brnikMarker);

                //OBREZJE
                let obrezjeContent =
                    '<div class="box-map d-flex align-items-start">' +
                    '<div class="location">' +
                    '<p class="mb-2">Obrežje</p>' +
                    '<div class="contact-info d-none">' +
                    '<p class="mb-1">Zaloška cesta 219</p>' +
                    '<p class="mb-1">+386 1 300 71 12</p>' +
                    '<p class="mb-1">dean.persic@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    unit +
                    '</div>' +
                    '</div>';


                let obrezjeWindow = new google.maps.InfoWindow({
                    content: obrezjeContent
                });

                obrezjeMarker = new google.maps.Marker({
                    position: { lat: 45.8494, lng: 15.6916 },
                    map,
                    icon: icon,
                })

                obrezjeMarker.addListener('click', function () {
                    infowindow.open(map, obrezjeMarker);
                });

                obrezjeWindow.open(map, obrezjeMarker);


                // CELJE
                let celjeContent =
                    '<div class="box-map d-flex align-items-start">' +
                    '<div class="location">' +
                    '<p class="mb-2">Celje</p>' +
                    '<div class="contact-info">' +
                    '<p class="mb-1">Kidričeva 34</p>' +
                    '<p class="mb-1">+386 3 425 76 12</p>' +
                    '<p class="mb-1">matjaz.suster@fersped.si</p>' +
                    '</div>' +
                    '</div>' +
                    '<div class="unit">' +
                    unit +
                    '</div>' +
                    '</div>';


                let celjeWindow = new google.maps.InfoWindow({
                    content: celjeContent
                });

                celjeMarker = new google.maps.Marker({
                    position: { lat: 46.2368, lng: 15.28782 },
                    map,
                    icon: icon,
                })

                celjeMarker.addListener('click', function () {
                    infowindow.open(map, celjeMarker);
                });

                celjeWindow.open(map, celjeMarker);




                window.initMap = initMap;



            })();
        }

        // Initialize and add the map
        if ($("#units").length > 0) {
            (function initMap() {


                const main = { lat: 44.968, lng: 15.4275579 };

                const map = new google.maps.Map(document.getElementById("units"), {
                    zoom: 8,
                    center: main
                });

                const icon = '/var/www/clients/client0/web286/web/wp-content/themes/emigma/assets/icons/empty.jpg';

                // LJ
                let mainContent =
                    '<div class="box-map d-flex align-items-start red">' +
                    '<div class="location">' +
                    '<p class="mb-2"p>Fersped d.o.o.</p>' +
                    '<span>Ljubljana</span>' +
                    '</div>' +
                    '</div>';

                let mainWindow = new google.maps.InfoWindow({
                    content: mainContent
                });

                mainMarker = new google.maps.Marker({
                    position: { lat: 46.01679410522044, lng: 14.50769740527312 },
                    map,
                    icon: icon,
                })

                mainMarker.addListener('click', function () {
                    infowindow.open(map, mainMarker);
                });

                mainWindow.open(map, mainMarker);



                // Zagreb
                let zgContent =
                    '<div class="box-map d-flex align-items-start blue">' +
                    '<div class="location">' +
                    '<p class="mb-2"p>CKTZ d.d.</p>' +
                    '<span>Zagreb</span>' +
                    '</div>' +
                    '</div>';

                let zgWindow = new google.maps.InfoWindow({
                    content: zgContent
                });

                zgMarker = new google.maps.Marker({
                    position: { lat: 45.78216402365058, lng: 15.978877703051058 },
                    map,
                    icon: icon,
                })

                zgMarker.addListener('click', function () {
                    infowindow.open(map, zgMarker);
                });

                zgWindow.open(map, zgMarker);




                //Sarajevo
                let sarajevoContent =
                    '<div class="box-map d-flex align-items-start blue">' +
                    '<div class="location">' +
                    '<p class="mb-2"p>Fercargo d.o.o.</p>' +
                    '<span>Sarajevo</span>' +
                    '</div>' +
                    '</div>';

                let sarajevoWindow = new google.maps.InfoWindow({
                    content: sarajevoContent
                });

                sarajevoMarker = new google.maps.Marker({
                    position: { lat: 43.84020876220039, lng: 18.408530775363147 },
                    map,
                    icon: icon,
                })

                sarajevoMarker.addListener('click', function () {
                    infowindow.open(map, sarajevoMarker);
                });

                sarajevoWindow.open(map, sarajevoMarker);


                window.initMap = initMap;



            })();
        }



        $('#trailer').on('click', function () {
            var video = $("#trailer").get(0);

            $(".play-btn").toggleClass('d-none');


            if (video.paused) {
                video.play();
                $(".play").hide();
                $(".pause").show();
            } else {
                video.pause();
                $(".play").show();
                $(".pause").hide();
            }

        });

        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if (!data) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action': action,
                        'data': data
                    },
                    type: 'POST',
                    success: function (response) {
                        if (response) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }


        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });


        $(document).find('*[data-fancybox]').fancybox();


        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }


        (function () {

            if (!isMobile) {
                let $frame = $('.frame'),
                    $scrollbar = $('.o-scrollbar');

                if ($frame.length > 0) {
                    dynamicElements.push(
                        {
                            'element': $frame,
                            'property': 'padding-left',
                            'callback': calcFluidPadding
                        }
                    );

                    $frame.css('padding-left', calcFluidPadding());

                    new Sly($frame, {
                        horizontal: 1,
                        itemNav: 'basic',
                        smart: 0,
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: 0,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: 'items'
                    }).init();
                }
            }

        })();


        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

            return ($('body').width() - $container.width()) / 2;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.m-wrapper-outer'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[a + 'Width'], height: e[a + 'Height'] };
        }

        $('.entry-content table').each(function () {
            $(this).addClass('table');
        });

        (function () {
            let $table = $('.table');
            if ($table.length > 0) {
                $table.each(function (i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();

        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len = this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        } else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

        //ARROW ANIMACIJA PRI LANG SWITCHERJU
        (function () {
            $('#ar-language-switcher').on('click', function (e) {
                $('#after-target').toggleClass('clicked');
                $('#after-target').toggleClass('clicked-reset');
            })
        })();

        //Close mobile nav menu on nav item click
        if (isMobile) {
            $('.nav-btn').on('click', function (e) {
                $('#burger-wrapper').trigger('click');
            })

            $('.unit').on('click', function () {
                console.log('dasdsad');
            })


        }

    });

})(jQuery);
